// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__oBPCZ","small":"avatar_small__owREX","avatarImage":"avatar_avatarImage__bG5QI"};